import React from "react";

import introFormat from "../../content/intro-screen/intro-screen"
import {CORILogo} from "../utilsJSX";
import USStatesToFilterWithinMenu from "../USStatesToFilterWithinMenu/USStatesToFilterWithinMenu";
import BigBoldHeader from '../BigBoldHeader'
import {coriLink} from "../../constants";


export default React.memo(
	() => (
		<div className='start-screen-full-page-background'>
			<div className="start-screen">
				
				<a id="cori-link" style={{position: 'absolute', left: '10px', top: '10px'}} href={coriLink} target="_blank" rel="noopener noreferrer">
					<CORILogo />
				</a>
				
				<div className={'start-screen-title-container'}>
					<div className="start-screen-title">{introFormat.titleText}</div>
				</div>
				
				<div className={`community-selection-wrapper`}>
					<BigBoldHeader headerText={'Choose US States to Explore'}/>
					
					<USStatesToFilterWithinMenu />
				</div>
			</div>
		</div>
	)
)
